export default {
  providerInfo: {
    id: 'trade_in_apac_provider_info',
    defaultMessage: 'This Trade-in program is provided by {provider, html}.',
  },
  providerNameAu: {
    id: 'trade_in_provider_name_au',
    defaultMessage: 'Renewable Mobile AU Pty Ltd ("RMA")',
  },
  providerNameJp: {
    id: 'trade_in_provider_name_jp',
    defaultMessage: '株式会社Belong',
  },
}
